module.exports = __webpack_public_path__ + "img/wedding_thumbnail-1-600x450.9519afb1.jpg";